module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Space Grey.12bda1bb.png";